import React from 'react';
import CustomSelect from './CustomSelect';

const CommonListPagination = ({
  pagination = { page: 1, limit: 10, total: 0, pages: 1 },
  entityLabel = 'items',
  loading = false,
  hasItems = true,
  onPageChange,
  onLimitChange
}) => {
  const { page = 1, limit = 10, total = 0, pages = 1 } = pagination || {};

  if (loading || !hasItems || total === 0) return null;

  const start = (page - 1) * limit + 1;
  const end = Math.min(page * limit, total);

  return (
    <div className="bg-gradient-to-r from-gray-100 to-gray-100 px-4 py-2 border-b border-gray-200 flex-shrink-0">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div className="flex items-center gap-2 text-sm">
          <span className="font-semibold text-gray-900">{start}-{end}</span>
          <span className="text-gray-500">of</span>
          <span className="font-semibold text-gray-900">{total}</span>
          <span className="text-gray-500 ml-1">{entityLabel}</span>
        </div>

        <div className="flex items-center gap-3">
          <div className="flex items-center gap-2">
            <span className="text-sm text-gray-600 font-medium">Show:</span>
            <CustomSelect
              id="limit-select"
              value={limit}
              onChange={(e) => onLimitChange?.(parseInt(e.target.value, 10))}
              options={[
                { value: 10, label: '10' },
                { value: 20, label: '20' },
                { value: 50, label: '50' },
                { value: 100, label: '100' }
              ]}
              size="sm"
              variant="minimal"
              className="min-w-[70px]"
            />
          </div>

          <div className="flex items-center gap-1">
            <button
              onClick={() => onPageChange?.(1)}
              disabled={page <= 1}
              className="p-1.5 rounded text-gray-400 hover:text-indigo-600 hover:bg-indigo-50 disabled:opacity-40 disabled:cursor-not-allowed transition-all"
              title="First page"
            >
              «
            </button>
            <button
              onClick={() => onPageChange?.(Math.max(1, page - 1))}
              disabled={page <= 1}
              className="px-2.5 py-1.5 rounded text-gray-600 hover:text-indigo-600 hover:bg-indigo-50 disabled:opacity-40 disabled:cursor-not-allowed transition-all font-medium text-sm"
            >
              Previous
            </button>

            <span className="px-3 py-1.5 text-sm font-semibold text-indigo-600 bg-indigo-50 rounded">
              {page} / {pages}
            </span>

            <button
              onClick={() => onPageChange?.(Math.min(pages, page + 1))}
              disabled={page >= pages}
              className="px-2.5 py-1.5 rounded text-gray-600 hover:text-indigo-600 hover:bg-indigo-50 disabled:opacity-40 disabled:cursor-not-allowed transition-all font-medium text-sm"
            >
              Next
            </button>
            <button
              onClick={() => onPageChange?.(pages)}
              disabled={page >= pages}
              className="p-1.5 rounded text-gray-400 hover:text-indigo-600 hover:bg-indigo-50 disabled:opacity-40 disabled:cursor-not-allowed transition-all"
              title="Last page"
            >
              »
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommonListPagination;
